<template lang="pug">
div
  v-slide-x-transition(leave-absolute)
    v-skeleton-loader.mt-2(
      type="heading"
      v-if="!course.title"
      transition="slide-x-transition"
    )
    v-row(v-else).ma-0.pa-0.align-center
      h1.text-h6 {{ course.title }}
  v-row
    v-col(
      cols=12 lg=8 order="2" order-lg="0"
    )
      v-row
        v-col(cols="12"  md="6")
          v-menu(v-if="course.id" offset-y)
            template(#activator="{ on }")
              v-list-item.sdo-shadow.sdo-radius.mt-2.card-hover.secondary.pr-2(
                v-on="on"
              )
                v-list-item-action.mr-4
                  v-icon(color="white" size="32") mdi-fountain-pen-tip
                v-list-item-content.white--text
                  .text-body-2: strong Курсовые задания
                  .text-caption Задание - {{course.tasks.length}}
                v-list-item-icon.ma-0.mt-2: v-icon(size="16" color="white") mdi-eye
            v-sheet
              v-list
                v-list-item(v-for="task in course.tasks" :key="task.id")
                  v-list-item
                    v-list-item-icon.mr-4: v-icon mdi-book-open-outline
                    v-list-item-content {{task.title}}
                    v-list-item-action
                      v-btn(
                        :to=`{
                          name: 'TaskEdit',
                          params: { id: task.id },
                          query: { model: 'courses', id: modelId }
                        }`
                        color="primary"
                        icon
                      )
                        v-icon mdi-pencil
                    v-list-item-action
                      v-btn(
                        @click="openDetachDialog(task.id, model)"
                        icon color="error" title="Удалить задание"
                      )
                        v-icon mdi-close
        v-col(cols="12"  md="6").pb-5
          v-list-item.sdo-shadow.sdo-radius.card-hover.pr-2.mt-2.fill-height(
            @click="openCreateTaskModal"
          )
            v-list-item-action.mr-4
              v-icon(color="primary" size="32") mdi-plus
            v-list-item-content
              .text-body-2.primary--text: strong Добавить задание
            v-list-item-icon.ma-0.mt-2: v-icon(size="16" color="primary") mdi-pencil-plus

            //- v-col.shrink
            //-   v-btn(
            //-     outlined
            //-     text
            //-     :to="{ name: 'CourseEnrollment' }"
            //-   ) Перейти к наборам

      v-sheet.mt-10
        unit-management(
          v-if="course.id"
          ref="unitManagement"
          :course="course"
          :editable="course.can_edit"
          :method="getCourseUnits"
          @removed:module="fetchModules"
        )

    v-scroll-y-transition
      v-col(cols=12 lg=4 )
        v-sheet.secondary.sdo-card(dark).pa-2
          .text-body-1.pl-2.pt-1.mb-2 Действия:
          v-list.transparent.px-2
            v-list-item(
              :disabled="!filteredModules.length" @click="openModules"
            ).secondary.lighten-1.pr-1.mb-3
              v-list-item-action.mr-4: v-icon mdi-school
              v-list-item-content.text-body-2: strong Добавить модуль
              v-list-item-icon.mt-2: v-icon(size="18") mdi-plus

            v-list-item.secondary.lighten-1.mb-3.pr-2(
              :to="{ name: 'CourseGPTSettings', params: { id: course.id } }"
            )
              v-list-item-action.mr-4: v-icon mdi-robot
              v-list-item-content.text-body-2: strong Настройки нейросети
              v-list-item-action: v-icon(size="20") mdi-arrow-right
            v-list-item.secondary.lighten-1.pr-1.mb-2(
              :disabled="course.course_units_count === 0"
              :to="{ name: 'TypicalQuestions', params: { id: course.id } }"
            )
              v-list-item-action.mr-4: v-icon mdi-frequently-asked-questions
              v-list-item-content.text-body-2: strong Типовые вопросы/ответы
              v-list-item-icon.mt-2: v-icon(size="15") mdi-pencil-plus
    //- portal(to="GPT.dialog" v-slot="{ close }")
    //-   v-sheet.pa-4
    //-     .d-flex.mb-4.align-center.px-1
    //-       .text-h6 Настройки нейросети
    //-       v-btn.ml-auto(icon @click="close"): v-icon mdi-close
    //-     gpt-settings

    portal(to="modules.dialog" v-slot="{ close }")
      v-card().sdo-card
        v-card-text
          .d-flex.mt-4
            .title Выберите модуль
            v-btn.ml-auto(@click="close" icon): v-icon mdi-close

          select-list-module(
            v-model="modules.selected"
            :items="filteredModules"
            :loading="modules.loading"
          )
          v-btn.mb-3(
            depressed
            block
            large
            :disabled="!modules.selected"
            color="success"
            light
            :loading="attach.loading"
            @click="attachModule"
          ) Добавить
</template>

<script>
import UnitManagement from '@/components/Unit/UnitManagement.vue';
import SelectListModule from '@/components/InputFields/course-module/SelectListModule.vue';
import GptSettings from '@/components/GPTSettings/index.vue';
import ChooseCreateTask from '@/components/Unit/ChooseCreateTask.vue';

export default {
  name: 'CourseUnitList',
  components: {
    GptSettings,
    UnitManagement,
    SelectListModule,
  },
  data: () => ({
    modules: {
      selected: null,
      items: [],
      loading: false,
    },
    course: {},

    attach: {
      loading: false,
    },
    loading: false,
  }),
  computed: {
    filteredModules() {
      return this.modules.items.filter((i) => !i.courses.find((c) => c.id === this.course.id));
    },
  },
  created() {
    this.init();
  },
  methods: {
    openDetachDialog(taskId, model) {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.$api.tasks.detachTask(
            taskId, {
              model,
              id: this.modelId,
            },
          );
          this.$emit('detachTask', taskId);
          this.$modals.close();
        },
      });
    },
    openCreateTaskModal() {
      this.$modals.show('generic-controller', {
        component: ChooseCreateTask,
        title: 'Создание задания',
        'component-props': {
          taskModel: 'courses',
          modelId: this.course.id,
        },
      });
    },
    openModules() {
      this.$modals.show('dialog-portal', {
        inputValue: 'modules',
      });
    },
    openGPT() {
      this.$modals.show('dialog-portal', {
        inputValue: 'GPT',
        dialogProps: {
          width: 800,
        },
      });
    },
    async init() {
      this.loading = true;
      await Promise.all([
        this.fetchCourse(),
        this.fetchModules(),
      ]);
      this.loading = false;
    },
    async fetchCourse() {
      const courseParams = {
        expand: 'edit,tasks,prior_records,course_units_count',
      };
      const { item } = await this.$api.courses.show(this.$route.params.id, courseParams);
      this.course = item;
    },
    getCourseUnits() {
      return this.$api.courseUnits.index({
        'search[course_id]': this.course.id,
        expand: 'lessons,course_modules,tasks',
      });
    },
    async fetchModules() {
      this.modules.loading = true;
      const { items } = await this.$api.modules.index({
        'search[user_id]': this.$user.data.id,
        expand: 'course_units_count,accepted_users_count,courses',
      });
      this.modules.items = items;
      this.modules.loading = false;
    },
    async attachModule() {
      this.attach.loading = true;
      await this.modules.selected.attach(this.course.id);
      this.$refs.unitManagement.init();
      this.fetchModules();
      this.attach.loading = false;
    },
  },
};
</script>
